import React from 'react';

const Servicios = () => {
  const servicios = [
    {
      icon: "📱",
      title: "Reparación de tablets",
      description: "Expertos en solucionar cualquier problema técnico: pantallas rotas, fallos de batería, software lento. Resultados duraderos y garantizados."
    },
    {
      icon: "👨‍🔧",
      title: "Técnicos certificados",
      description: "Equipo calificado con años de experiencia. Tu tablet volverá a funcionar como nueva, rápida y eficientemente."
    },
    {
      icon: "🖥️",
      title: "Reparación multimarca",
      description: "Móviles, tablets, ordenadores, consolas... Todas las marcas y modelos. Soluciones integrales para todos tus dispositivos."
    }
  ];

  return (
    <div>
      <div className="container">
        <div className="section-header">
          <h2>Servicios premium</h2>
          <div className="underline"></div>
          <p style={{ marginTop: '1rem', color: '#6B7280', fontSize: '1.1rem' }}>
            📱 Reparación de tablets en Palafolls: tu solución experta y local
          </p>
        </div>

        <div className="card-container">
          {servicios.map((servicio, index) => (
            <div className="card" key={index}>
              <div className="card-content">
                <div style={{ fontSize: '3rem', textAlign: 'center', marginBottom: '1rem' }}>{servicio.icon}</div>
                <h3 style={{ textAlign: 'center' }}>{servicio.title}</h3>
                <p style={{ textAlign: 'center' }}>{servicio.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div style={{ 
          textAlign: 'center', 
          padding: '3rem', 
          background: '#F9FAFB', 
          borderRadius: '32px', 
          marginTop: '2rem',
          border: '1px solid #E5E7EB'
        }}>
          <h3 style={{ fontFamily: "'Playfair Display', serif", fontSize: '1.6rem', color: '#1A1A1A' }}>🚀 No dejes que un equipo roto te detenga</h3>
          <p style={{ marginTop: '1rem', color: '#6B7280' }}>Ven a Phone Paradise y permite que los especialistas cuiden de tus dispositivos.</p>
          <button className="btn" style={{ marginTop: '1.5rem' }}>
            Contactar ahora
          </button>
        </div>
      </div>
    </div>
  );
};

export default Servicios;